export default () => {
  const overlays = document.querySelectorAll('[data-overlay]');

  const classes = {
    overlayOpen: 'overlay--open',
  };

  if (overlays.length) {
    overlays.forEach((overlay) => {
      // elements

      const els = {
        openButton: document.querySelectorAll(`[data-overlay-open="${overlay.id}"]`),
        closeButton: overlay.querySelectorAll('[data-overlay-close]'),
      };

      // functions
      const openOverlay = () => {
        overlay.classList.add(classes.overlayOpen);
        document.body.style.overflow = 'hidden';
      };

      const closeOverlay = () => {
        overlay.classList.remove(classes.overlayOpen);
        document.body.style.overflow = '';
      };

      // handlers
      const handleClickOpen = (e) => {
        e.preventDefault();
        openOverlay();
      };

      const handleClickClose = (e) => {
        e.preventDefault();
        closeOverlay();
      };

      // apply event listeners
      els.openButton.forEach((el) => el.addEventListener('click', handleClickOpen));
      els.closeButton.forEach((el) => el.addEventListener('click', handleClickClose));
    });
  }
};
